import { render, staticRenderFns } from "./ChartVue.vue?vue&type=template&id=2636d013"
import script from "./ChartVue.vue?vue&type=script&lang=js"
export * from "./ChartVue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports